// extracted by mini-css-extract-plugin
export default {"rulerIcon":"_3eff7c26"};